import React from "react";

import { postRequest } from "../../utils/apiHandlers";

const EMPTY = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  adults: "",
  children: "",
  arrivalDate: "",
  departureDate: "",
  breakfast: "",
  website: "", //Honeypot
};

const today = () => new Date().toISOString().slice(0, 10);

const Field = ({ label, isRequired = false, className = "", children }) => (
  <label className={`group-field ${className}`}>
    <span className={"group-label"}>
      {label}
      {isRequired ? <span aria-hidden={"true"}>*</span> : null}
    </span>
    {children}
  </label>
);

//"Group Booking Enquiry" on the Contact page. Wix used separate Year / Month / Day boxes for the dates - now a date picker
const GroupBookingForm = () => {
  const [form, setForm] = React.useState(EMPTY);
  const [isSending, setIsSending] = React.useState(false);
  const [errorText, setErrorText] = React.useState("");
  const [sentTo, setSentTo] = React.useState(null);

  const update = (prop) => (e) => setForm({ ...form, [prop]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setErrorText("");
    setIsSending(true);
    try {
      await postRequest("/Contact/SendGroupBookingEnquiry", form);
      setSentTo(form.firstName);
      setForm(EMPTY);
    }
    catch (err) {
      setErrorText(err.message);
    }
    setIsSending(false);
  };

  if (sentTo !== null) {
    return (
      <div
        className={"group-done"}
        role={"status"}
      >
        <p>Thank you{sentTo ? `, ${sentTo}` : ""}! Your group booking enquiry has been sent - we&apos;ll be in touch with rates soon.</p>
        <button
          type={"button"}
          className={"btn group-submit"}
          onClick={() => setSentTo(null)}
        >
          Send another enquiry
        </button>
      </div>
    );
  }

  return (
    <form
      className={"group-form"}
      onSubmit={onSubmit}
    >
      <Field label={"First name"}>
        <input
          type={"text"}
          value={form.firstName}
          onChange={update("firstName")}
          maxLength={100}
          autoComplete={"given-name"}
        />
      </Field>
      <Field label={"Last name"}>
        <input
          type={"text"}
          value={form.lastName}
          onChange={update("lastName")}
          maxLength={100}
          autoComplete={"family-name"}
        />
      </Field>
      <Field
        label={"Email"}
        isRequired
        className={"is-wide"}
      >
        <input
          type={"email"}
          value={form.email}
          onChange={update("email")}
          required
          maxLength={200}
          autoComplete={"email"}
        />
      </Field>
      <Field
        label={"Phone"}
        className={"is-wide"}
      >
        <input
          type={"tel"}
          value={form.phone}
          onChange={update("phone")}
          maxLength={50}
          autoComplete={"tel"}
        />
      </Field>
      <Field label={"How many Adults?"}>
        <input
          type={"number"}
          value={form.adults}
          onChange={update("adults")}
          min={0}
          max={500}
          inputMode={"numeric"}
        />
      </Field>
      <Field label={"How many Children?"}>
        <input
          type={"number"}
          value={form.children}
          onChange={update("children")}
          min={0}
          max={500}
          inputMode={"numeric"}
        />
      </Field>
      <Field label={"Date of Arrival?"}>
        <input
          type={"date"}
          value={form.arrivalDate}
          onChange={update("arrivalDate")}
          min={today()}
        />
      </Field>
      <Field label={"Date of Departure?"}>
        <input
          type={"date"}
          value={form.departureDate}
          onChange={update("departureDate")}
          min={form.arrivalDate || today()}
        />
      </Field>

      <fieldset className={"group-radios is-wide"}>
        <legend className={"group-label"}>Would you like to include Breakfast?</legend>
        {["Yes", "No"].map((option) => (
          <label key={option}>
            <input
              type={"radio"}
              name={"breakfast"}
              value={option}
              checked={form.breakfast === option}
              onChange={update("breakfast")}
            />
            <span>{option}</span>
          </label>
        ))}
      </fieldset>

      <label
        className={"form-honeypot"}
        aria-hidden={"true"}
      >
        Website
        <input
          type={"text"}
          value={form.website}
          onChange={update("website")}
          tabIndex={-1}
          autoComplete={"off"}
        />
      </label>

      {errorText ? (
        <p
          className={"group-error is-wide"}
          role={"alert"}
        >
          {errorText}
        </p>
      ) : null}

      <button
        type={"submit"}
        className={"btn group-submit is-wide"}
        disabled={isSending}
      >
        {isSending ? "Sending..." : "Submit"}
      </button>
    </form>
  );
};

export default GroupBookingForm;
